export const embedURL = (url) => {
  const root = "https://iframe.ly/api/iframely"
  const key = "b8a640388fb50cfa2f18b0"
  const query = `${root}?url=${url}&api_key=${key}&omit_script=true&iframe=true`

  return new Promise((resolve, reject) => {
    fetch(query)
      .then((res) => res.json())
      .then((res) => {
        if (res.error) {
          reject(res.error)
        } else {
          resolve(res)
        }
      })
      .catch((err) => {
        reject(new Error(err))
      })
  })
}

// TODO: implement a better embed verification
// This check is too stringent, not allowing for external embeds
// const iframelyCanLoad = () => {
//   return (
//     document.querySelectorAll("[data-iframely-url]").length ||
//     document.querySelectorAll("iframe[src*='iframe.ly']").length
//   )
// }

// Replace 'iframe.ly' with your custom CDN if available.
export const loadIframely = () => {
  // console.log("trying to load iframely")
  // if (!iframelyCanLoad()) return
  // console.log("iframely can load")

  var iframely = (window.iframely = window.iframely || {})
  var widgets = (iframely.widgets = iframely.widgets || {})
  if (widgets.load) {
    // console.log("Have widgets")
    widgets.load()
  } else {
    var ifs = document.createElement("script")
    ifs.type = "text/javascript"
    ifs.async = true
    ifs.src =
      ("https:" === document.location.protocol ? "https:" : "http:") +
      "//cdn.iframe.ly/embed.js"
    var s = document.getElementsByTagName("script")[0]
    s.parentNode.insertBefore(ifs, s)
  }
  return true
}

// export const verifyEmbed = () => {
//   // Add additional conditions for embedding here
//   const hasIframe = document.querySelectorAll("iframe").length

//   return iframelyCanLoad() || hasIframe
// }
